import CreateEmployee from './CreateEmployee'
import { EmployeesDataProvider } from '../context/EmployeesContext';

export default function CreateEmployeePage() {
  return (
    <div className="employee-detail-page">
      <EmployeesDataProvider>
        <CreateEmployee />
      </EmployeesDataProvider>
    </div>
  );
}